<template>
  <van-popup class="hot-games-popup" v-model:show="visible" teleport="body" :close-on-click-overlay="false">
    <div class="hot-games-page">
      <van-nav-bar
        class="game-page-header"
        z-index="1000"
        title="热门游戏"
        left-arrow
        safe-area-inset-top
        @click-left="visible = false"
      />
      <div class="game-page-content" v-if="visible">
        <game-list :type="GameMainTypesEnum.HOT_GAME">
          <template #default="item">
            <hot-game-card :item="item" @click="onGameClick(item)" />
          </template>
        </game-list>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { defineModel, onBeforeMount } from 'vue';
import { useI18n } from '@star/languages';
import GameList from './GameList.vue';
import { GameMainTypesEnum } from '@star/constants';
import HotGameCard from './gameCards/HotGameCard.vue';
import { openGame } from '@/pages/home/index';

// type Props = {
//
// };
//
// const props = withDefaults(defineProps<Props>(), {
//
// });

const { n } = useI18n();
const visible = defineModel<boolean>();

const onGameClick = (item: any) => {
  console.log(item, 'onGameClick');
  openGame(item);
};

onBeforeMount(async () => {});
</script>

<style lang="less" scoped>
.hot-games-popup {
  // width: 100%;
  width: 100vw;
  height: 100%;
  overflow: hidden;

  .hot-games-page {
    width: 100%;
    height: 100%;
    background: #f4f4f4;
    display: flex;
    flex-direction: column;

    .game-page-header {
      flex: none;
    }

    .game-page-content {
      flex: 1;
      overflow-y: auto;
    }
  }
}

.notice-wrapper {
  width: 949px;
  min-height: 764px;
  border-radius: 60px;
  background-image: url('@assets/img/home/sys_repair_bg.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top center;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .header {
    height: 330px;
    position: relative;
    flex: none;
    display: flex;
    align-items: flex-end;

    .title {
      font-size: 62px;
      font-weight: 600;
      color: #000;
      text-align: center;
    }

    .notice-icon {
      position: absolute;
      left: calc(50% - 370px / 2);
      top: -180px;
      width: 370px;
    }
  }

  .content {
    flex: 1;
    border-radius: 60px;
    padding: 60px 80px;
    text-align: justify;
    line-height: 1.3;
    font-size: 42px;
    color: #000;
    font-weight: 300;
  }
}
</style>
